'use client';

import dynamic from 'next/dynamic';

const WhyReactRendersDemo = dynamic(() => import('./index'));

export default WhyReactRendersDemo;
